import { motion } from "framer-motion";
import { Overline } from "./Primitives";

const EASE = [0.16, 1, 0.3, 1];

export const PageHero = ({ overline, title, subtitle, children }) => (
  <section data-testid="page-hero" className="relative pt-36 md:pt-44 pb-16 md:pb-20 bg-brand-blush overflow-hidden">
    <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-brand-pink/50 blur-3xl" />
    <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-10">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease: EASE }}>
        {overline && <Overline className="mb-5">{overline}</Overline>}
        <h1 className="font-serif font-light text-brand-ink text-5xl sm:text-6xl lg:text-7xl leading-[0.98] tracking-tight max-w-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="text-brand-ink/70 font-light text-lg mt-6 max-w-2xl leading-relaxed">{subtitle}</p>
        )}
        {children && <div className="mt-9 flex flex-wrap gap-4">{children}</div>}
      </motion.div>
    </div>
  </section>
);

export default PageHero;
